<template>
  <div>
    <breadcrumbs home="Wine"/>

    <v-card flat>
      <v-tabs v-model="tab" class="full-height-tab" show-arrows>
        <v-tab>Info</v-tab>
        <v-tab>Purchasing</v-tab>
        <v-tab>Selling</v-tab>

        <v-tab-item>
          <wine-edit-info :wine="wine" :accounts="inventoryAccounts" :values="values" ref="info"/>
        </v-tab-item>
        <v-tab-item eager>
          <wine-edit-buying :wine="wine" :taxes="taxes.filter(tax => tax.purchaseRate !== null)" ref="buying"/>
        </v-tab-item>
        <v-tab-item eager>
          <wine-edit-selling :wine="wine" :taxes="taxes.filter(tax => tax.salesRate !== null)" :values="values" :incomeAccounts="incomeAccounts" :cogAccounts="cogAccounts" ref="selling"/>
        </v-tab-item>
      </v-tabs>

      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import WineEditInfo from '@/views/alcohol/wine/WineEditInfo'
import WineEditBuying from '@/views/alcohol/wine/WineEditBuying'
import WineEditSelling from '@/views/alcohol/wine/WineEditSelling'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'WineEdit',
  mixins: [confirmLeave],
  components: {WineEditInfo,WineEditBuying,WineEditSelling},
  props: {
    wineId: {type:String, required:false}
  },
   data () {
      return {
        accounts: [],
        taxes: [],
        wine: {vendors:[],customers:[]},
        dirty: false,
        saving: false,
        loading: false,
        tab: 0
      }
    },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    },
    inventoryAccounts() {
      return this.accounts.filter(account => account.type === 'OtherCurrentAsset');
    },
    incomeAccounts() {
      return this.accounts.filter(account => account.type === 'Income');
    },
    cogAccounts() {
      return this.accounts.filter(account => account.type === 'CostOfGoodsSold');
    },
    values() {
      return this.$store.getters.company.permissions.includes('values') && this.$store.getters.company.settings.useAccounts;
    }
  },
  watch: {
    wine: {
      handler() {this.dirty=true},
      immediate: true,
      deep: true
    }
  },
  async created() {
    this.loading = true;
    this.$lazyListLoad(this.taxes, 'taxes2', 'id,name,salesRate,purchaseRate', 100);
    const results = await this.$apiCall(`query WineEdit($currency:String!,$edit:Boolean!,$id:ID!) {
                                              accounts(currency:$currency) {
                                                ref,name,type
                                              }
                                              companyAccounts @skip(if:$edit) {wineInventory,wineCOG,wineIncome}
                                              wine(id:$id) @include(if:$edit) {
                                                id,name,sku,type,active,
                                                reorderPoint,
                                                inventoryAccountRef,incomeAccountRef,cogAccountRef,
                                                reorderQuantity,reorderDays,reorderBusinessDays,
                                                buyingDescription,preferredVendor{id},
                                                sellingDescription,defaultPrice,defaultTax{id}
                                                vendors{vendorId,tax{id},sku,cost},commissionExempt,
                                                customers{category,customerId,tax{id},sku,price},
                                              }
                                            }`,
                                        {currency:this.$store.getters.company.settings.homeCurrency,
                                         edit:this.wineId!=undefined,id:this.wineId || ''});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }

    this.accounts = results.data.accounts;

    if (this.wineId) {
      this.wine = {...results.data.wine,
                   preferredVendorId:results.data.wine.preferredVendor?.id,preferredVendor:undefined,
                   defaultTaxId:results.data.wine.defaultTax?.id,defaultTax:undefined,
                   vendors:results.data.wine.vendors.map(v => ({...v,taxId:v.tax.id,tax:undefined})),
                   customers:results.data.wine.customers.map(c => ({...c,taxId:c.tax.id,tax:undefined}))
                  };
      if (this.$route.query.tab)
        this.tab = parseInt(this.$route.query.tab);
    }
    else {
      this.wine = {name:'',sku:'',type:'WineHigh',active:true,
                   reorderPoint:-1,reorderQuantity:0,reorderDays:0,reorderBusinessDays:false,
                   inventoryAccountRef:results.data.companyAccounts.wineInventory,
                   incomeAccountRef:results.data.companyAccounts.wineIncome,
                   cogAccountRef:results.data.companyAccounts.wineCOG,commissionExempt:false,
                   buyingDescription:'',vendors:[],preferredVendorId:null,
                   sellingDescription:'',defaultPrice:0,defaultTaxId:null,customers:[]};
    }
    this.$nextTick(() => {this.dirty = false});
    this.loading = false;
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      let valid = true;
      if (!this.$refs.info.valid) {
        this.tab = 0;
        valid = false;
      }
      else if (this.$refs.buying && !this.$refs.buying.valid) {
        this.tab = 1;
        valid = false;
      }
      else if (this.$refs.selling && !this.$refs.selling.valid) {
        this.tab = 2;
        valid = false;
      }

      if (!valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      const input = Object.assign({}, this.wine);
      if (this.wine.id)
        delete input.type;
      const results = await this.$apiCall(`mutation WineEdit($input: WineInput!) {
                                             wineCreate(input:$input) {id}
                                           }`,
                                          {input})
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.wine.id?'Updated':'Created'} wine ${this.wine.name}`});
      }
    }
  }
}
</script>